<div
  class="preview-container"
  [ngClass]="{ 'preview-list': !isCalledFromCreation }"
  *ngIf="title || formData.content"
>
  <div class="preview-texts">
    <p class="title-text fw-bold" title="{{ title }}">
      {{ title.length > 25 ? title.slice(0, 25) + "... " : title }}
    </p>
    <p class="message-text" title="{{ formData.content }}">
      {{
        formData.content.length > 100
          ? formData.content.slice(0, 100) + "... "
          : formData.content
      }}
    </p>
  </div>
</div>
